// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"ff5c1393","453":"f6713f7b","796":"9dab3b66"}[chunkId] + ".chunk.js";
};